<template>
  <v-toolbar dark dense color="primary" @click="home">
    <img style="width:32px;height:32px;margin-right:1rem" src="/img/icons/android-chrome-192x192.png">
    <v-toolbar-title class="white--text" style="padding:0;margin:0">Bentomax</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
      <v-icon @click="logout">exit_to_app</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn
    },
  },
  methods: {
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    },
    home: function() {
      this.$router.push('/')
    },
  },
}
</script>